import {Injectable} from '@angular/core';
import {Router, CanActivate} from '@angular/router';

@Injectable()
export class AuthAdminGuard implements CanActivate {

  constructor(private router: Router) {
  }
  canActivate() {
   const account = localStorage.getItem('currentSmmAccount') !== undefined &&
    localStorage.getItem('currentSmmAccount') !== 'undefined' ?
      JSON.parse(localStorage.getItem('currentSmmAccount')) : {};
    if(account.admin)
    {
        return true;
    }else
    {
        this.router.navigate(['/dashboard']);
    }
    return false;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_guards/auth-admin.guard.ts